@if (errorService.serverError(); as serverError) {
	<error-page [status]="serverError" (logout)="logout()"></error-page>
} @else {
	<div
		class="app absolute top-0 w-full h-auto bottom-14.5 overflow-x-hidden overflow-y-auto lg:bottom-0 lg:overflow-hidden lg:relative lg:top-0 lg:mx-auto lg:my-0 lg:h-screen lg:max-w-480 before:block before:content-['']"
		[class]="pageName$ | async"
	>
		<div
			class="h-full min-h-full px-4 pt-4 w-full lg:overflow-hidden lg:h-screen lg:border-solid lg:border-r lg:border-secondary-200 lg:max-w-480"
		>
			<ui-nav
				class="hide-mobile"
				[items]="desktopMenuPoints$ | async"
				[environment]="environment"
				[apps]="appNavMenuPoints$ | async"
				[activeApp]="activeApp"
				[currentUrl]="currentUrl$ | async"
				(callbackEvent)="navCallback($event)"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
			></ui-nav>
			<ui-mobile-nav
				class="hide-desktop"
				[items]="mobileMenuPoints$ | async"
				[environment]="environment"
				[apps]="appNavMenuPoints$ | async"
				[currentUrl]="currentUrl$ | async"
				(callbackEvent)="navCallback($event)"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
			></ui-mobile-nav>

			<div
				class="h-full lg:absolute lg:top-0 lg:px-8 lg:pt-8 lg:left-17 lg:w-[calc(100%-4rem)]"
				[class]="pageName$ | async"
			>
				<router-outlet></router-outlet>
				@if (error$ | async; as error) {
					<ui-overlay
						(closeOverlay)="onClose()"
						[showCloseButton]="true"
						[header]="error.type + '.header' | lowercase | translate"
					>
						<ui-error-content [error]="error" (closed)="onClose()"></ui-error-content>
					</ui-overlay>
				}
			</div>
		</div>
	</div>
	@if (helpOpen) {
		<ui-overlay [header]="'help_overlay.title' | translate" (closeOverlay)="onCloseHelp()">
			<ui-help-content (closed)="onCloseHelp()"></ui-help-content>
		</ui-overlay>
	}

	<toast-container></toast-container>
	<cookie-overlay></cookie-overlay>
}
